import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-invites',
  templateUrl: './invites.component.html',
  styleUrls: ['./invites.component.css']
})
export class InvitesComponent implements OnInit {
  invites: any[] = [];
  packages: any[] = [];
  showCreateModal = false;
  newLabel: string = '';
  newPackageId: any = '';
  newExpiresInDays: any = 30;

  constructor(private apiService: ApiService) {}

  truncate(text: string, length: number = 60): string {
    if (!text) return '';
    return text.length > length ? text.substring(0, length) + '...' : text;
  }

  ngOnInit(): void {
    this.loadInvites();
    this.loadPackages();
  }

  loadInvites() {
    this.apiService.getInvites().subscribe(
      (response) => {
        this.invites = response.Invites;
      }
    );
  }

  loadPackages() {
    this.apiService.getPackages('your-auth-token').subscribe(
      (response) => {
        this.packages = response.Package.filter((pkg: any) => pkg.id != 97);
      }
    );
  }

  openCreateModal() {
    this.newLabel = '';
    this.newPackageId = '';
    this.newExpiresInDays = 30;
    this.showCreateModal = true;
  }

  closeCreateModal() {
    this.showCreateModal = false;
  }

  createInvite() {
    this.apiService.createInvite(this.newPackageId, this.newLabel, this.newExpiresInDays).subscribe(
      (response) => {
        this.closeCreateModal();
        this.loadInvites();
      },
      (error) => {
        alert('Failed to create invite');
      }
    );
  }

  deleteInvite(id: number) {
    if (!confirm('Delete this invite?')) return;

    this.apiService.deleteInvite(id).subscribe(
      () => {
        this.loadInvites();
      }
    );
  }

  isExpired(invite: any): boolean {
    return invite.expires_at && new Date(invite.expires_at) < new Date();
  }

  getInviteLink(token: string): string {
    return `https://umyogossip.site/?invite_token=${token}`;
  }

  copyLink(token: string) {
    navigator.clipboard.writeText(this.getInviteLink(token));
    alert('Link copied!');
  }
}